/**
 * The panel header workaround modifies the category search filters and allows to collapse/de-collapse a filter by
 * clicking on the filters titlt tag <... class="... ais-Panel ...">
 */

$(document).ready(
    function () {
        $('#searchFilter .ais-Panel--collapsible .ais-Panel-header').each(function (index, element) {
            $(element).css('cursor', 'pointer');
            $(element).click(function () {
                if ($(this).parent().hasClass('ais-Panel--collapsed')) {
                    $(this).parent().removeClass('ais-Panel--collapsed')
                } else {
                    $(this).parent().addClass('ais-Panel--collapsed')
                }
            });
        });
    }
);
